
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSafetyCountourOffProposal as ObiChartSafetyCountourOffProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-safety-countour-off-proposal.js';
 
 
 

 
 export const ObiChartSafetyCountourOffProposal = createComponent({
   react: React,
   tagName: 'obi-chart-safety-countour-off-proposal',
   elementClass: ObiChartSafetyCountourOffProposalElement,
   events: {
     
   }
  });
 
 